export default __webpack_public_path__ + "static/brand-6-504b853d79a8f59b572313b351c350ba.png";